
import { Component, OnInit } from '@angular/core';
import { TestService } from '../../services/test.service';

@Component({
  selector: 'app-documentation',
  templateUrl: './documentation.component.html',
  styleUrls: ['./documentation.component.scss']
})
export class DocumetationComponent implements OnInit {
  showFiller = false;
  constructor(private testService: TestService) { }
  columns = [];
  data = [];
  opened = true;
  ngOnInit() {
    this.testService.getRegularTableData().then(r => {
      this.columns = this.iterateObject(r.columns);
      this.data = r.data;
    }
    );
  }

  iterateObject(o) {
    const array = [];
    for (const key in o) {
      if (o.hasOwnProperty(key)) {
        array.push(o[key]);
      }
    }
    return array;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/documentation/documentation.component.ts